import React, { Fragment, useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import { useNavigate } from "react-router-dom";
import { listPatients } from "../actions/patientActions";
import { Button, Dropdown } from "antd";
import AddAppVaccineModal from "../component/modal/addAppointment";

const Menu = () => {
	const [searchTerm, setSearchTerm] = useState("");
	const [selectedPatient, setSelectedPatient] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [query, setQuery] = useState("");
	const [filteredResults, setFilteredResults] = useState([]);
	const [debounceTimer, setDebounceTimer] = useState(null);

	const [showList, setShowList] = useState(false);
	const [patientId, setPatientId] = useState(null);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	const patientList = useSelector((state) => state.patientList);
	const { patients } = patientList;

	const logoutHandler = () => {
		dispatch(logout());
	};
	useEffect(() => {
		if (userInfo) {
			dispatch(listPatients({}));
		} else {
			navigate("/signin");
		}
	}, [dispatch, userInfo]);
	// Cleanup debounce timer on component unmount
	useEffect(() => {
		return () => {
			if (debounceTimer) {
				clearTimeout(debounceTimer);
			}
		};
	}, [debounceTimer]);

	// Debounced search function
	const debouncedSearch = useCallback(
		(searchInput) => {
			if (searchInput.trim()) {
				dispatch(listPatients({ firstName: searchInput }));
			} else {
				dispatch(listPatients({}));
			}
		},
		[dispatch]
	);

	const handleInputChange = (e) => {
		const input = e.target.value;
		setQuery(input);

		// Clear existing timer
		if (debounceTimer) {
			clearTimeout(debounceTimer);
		}

		// Set new timer for debounced search
		const newTimer = setTimeout(() => {
			debouncedSearch(input);
		}, 5000); // 5000ms delay (5 seconds)

		setDebounceTimer(newTimer);
		setShowList(input.length > 0);
	};

	useEffect(() => {
		setFilteredResults(patients);
	}, [patients]);

	const handleItemClick = (item) => {
		setQuery(item.firstName); // Fill input with the selected item's name
		setShowList(false); // Hide the list
		setPatientId(item._id);
		setShowModal(true);
	};

	const items = [
		{
			key: " add-patient",
			label: " Add Patient",
			onClick: (e) => {
				navigate("/add-patient-details");
			},
		},
	];

	return (
		<>
			{showModal && (
				<AddAppVaccineModal
					show={showModal}
					onClose={() => setShowModal(false)}
					patientId={patientId}
				/>
			)}
			<nav
				className="sb-topnav navbar navbar-expand-lg navbar-light"
				style={{ backgroundColor: "#f9f9f9", borderBottom: "1px solid #ddd" }}
			>
				<Link
					className="navbar-brand"
					to="/"
					style={{
						color: "black",
						fontFamily: "Roboto sans-serif",
						fontSize: "14px",
						fontWeight: 700,
					}}
				>
					Ravi Neuro - Psychiatry Centre
				</Link>
				{window.location.pathname !==
					("/list-patients" && "/patient-app-details") ? (
					<div className="container-fluid">
						<button
							className="navbar-toggler"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#navbarNav"
							aria-controls="navbarNav"
							aria-expanded="false"
							aria-label="Toggle navigation"
						>
							<span className="navbar-toggler-icon"></span>
						</button>

						<div className="collapse navbar-collapse" id="navbarNav">
							<form
								className="d-flex ms-auto me-3"
								style={{ maxWidth: "300px", width: "100%" }}
							>
								<div className="mb-3">
									<input
										type="text"
										placeholder=" Search..."
										value={query}
										onChange={handleInputChange}
										style={{
											width: "100%",
											padding: "3px",
											marginTop: "25px",
											fontSize: "16px",
											borderRadius: "10px",
										}}
									/>
									{showList && (
										<ul
											style={{
												position: "fixed",
												top: "50px",
												listStyleType: "none",
												padding: "0",
												margin: "0",
												border: "1px solid #ddd",
												borderRadius: "4px",
												maxHeight: "150px",
												overflowY: "auto",
												backgroundColor: "#fff",
											}}
										>
											{filteredResults && filteredResults.patient.length > 0 ? (
												filteredResults.patient.map((item) => (
													<li
														key={item._id}
														onClick={() => handleItemClick(item)}
														style={{
															padding: "10px",
															cursor: "pointer",
															transition: "background-color 0.2s",
														}}
														onMouseEnter={(e) =>
															(e.target.style.backgroundColor = "#f0f0f0")
														}
														onMouseLeave={(e) =>
															(e.target.style.backgroundColor = "#fff")
														}
													>
														{item.firstName + " " + item.lastName +  "-" + item.patientNumber}
													</li>
												))
											) : (
												<li style={{ padding: "10px", color: "#999" }}>
													No matching results
												</li>
											)}
										</ul>
									)}
								</div>
							</form>
						</div>
						<Dropdown.Button
							menu={{ items }}
							onClick={() => {
								setShowModal(true);
								setPatientId(null);
							}}
							type="primary"
							className="m-2 mb-3"
						>
							Add Appointment
						</Dropdown.Button>
					</div>
				) : (
					<div className="container-fluid"></div>
				)}

				<ul className="navbar-nav ml-auto ml-md-0">
					<li className="nav-item dropdown">
						<a
							className="nav-link dropdown-toggle"
							id="userDropdown"
							href="#"
							role="button"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
						>
							<i className="fas fa-user fa-fw"></i>
						</a>
						<div
							className="dropdown-menu dropdown-menu-right"
							aria-labelledby="userDropdown"
						>
							<a className="dropdown-item" href="#">
								Settings
							</a>
							<a className="dropdown-item" href="#">
								Activity Log
							</a>
							<div className="dropdown-divider"></div>
							<a className="dropdown-item" onClick={logoutHandler}>
								Logout
							</a>
						</div>
					</li>
				</ul>
			</nav>
		</>
	);
};

export default Menu;
